import React, { useEffect, useState } from "react";
import { Gift, Users, Sparkles } from "lucide-react";
import api from "../lib/api";

export const ReferralDashboard = () => {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/referrals").then((r) => setData(r.data)).catch(() => {}); }, []);
  if (!data) return null;
  return (
    <div className="rounded-xl border border-[#E2E8F0] bg-white overflow-hidden mt-6" data-testid="referral-dashboard">
      <div className="px-5 py-4 border-b border-[#E2E8F0] flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2"><Gift size={16} className="text-[#059669]" /><span className="text-sm font-bold text-[#0F172A]">Your referrals</span></div>
        <div className="flex items-center gap-4 text-xs text-[#64748B]">
          <span className="inline-flex items-center gap-1.5" data-testid="referral-total-count"><Users size={13} /> {data.total_referrals} referred</span>
          <span className="inline-flex items-center gap-1.5 font-semibold text-[#059669]" data-testid="referral-total-bonus"><Sparkles size={13} /> +{data.bonus_slots} storage earned</span>
        </div>
      </div>
      {data.referrals.length === 0 ? (
        <p className="px-5 py-6 text-sm text-[#94A3B8] text-center" data-testid="referral-empty">No referrals yet — share your link to earn +{data.per_referral} storage per business.</p>
      ) : (
        <div>
          <div className="hidden sm:grid grid-cols-12 px-5 py-2 text-[11px] font-semibold uppercase tracking-wider text-[#94A3B8] bg-slate-50">
            <div className="col-span-5">Business</div><div className="col-span-4">Joined</div><div className="col-span-3 text-right">Bonus</div>
          </div>
          {data.referrals.map((r) => (
            <div key={r.user_id} data-testid={`referral-row-${r.user_id}`} className="grid sm:grid-cols-12 gap-1 px-5 py-3 border-t border-[#F1F5F9] text-sm items-center">
              <div className="sm:col-span-5">
                <p className="font-semibold text-[#0F172A]">{r.business_name || r.name || "New business"}</p>
                <p className="text-xs text-[#64748B]">{r.email_masked}</p>
              </div>
              <div className="sm:col-span-4 text-xs text-[#64748B]">{r.joined_at ? new Date(r.joined_at).toLocaleDateString() : "—"}</div>
              <div className="sm:col-span-3 text-right font-mono font-semibold text-[#059669]">+{r.bonus}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
